import { computed } from 'vue'
import { DevicePid, KK, kks } from '@/define/define'
import { BaseDevice } from './base_device'
import { AL87 } from './keyboard/al87/al87'
import { AL87PRO } from './keyboard/al87/al87_pro'
import { AL87RGB } from './keyboard/al87/al87_rgb'
import { FE75PRO } from './keyboard/fe/fe75_pro'
import { He2 } from './mouse/he2'
import { FE98PRO } from './keyboard/fe/fe98_pro'
import { Mg87 } from './keyboard/mg87'
import { OP75 } from './keyboard/op75'
import { TP87 } from './keyboard/tp87'
import { LI75 } from './keyboard/li75'
import { Mt87 } from './keyboard/mt87'
import { DeviceManager } from '@/service/device'
import { Mu68 } from './keyboard/mu68/mu68'
import { ND75 } from './keyboard/nd/nd75'
import { NA87 } from './keyboard/na/na87'
// import { He3 } from "./mouse/he3";
import { He3SE } from './mouse/he3_se'
import { NA87Pro } from './keyboard/na/na87_pro'
import { Mu68Pro } from './keyboard/mu68/mu68_pro'
import { ND63 } from './keyboard/nd/nd63'
import { ND63Cyan } from './keyboard/nd/nd63_cyan'
import { Mu68Ultra } from './keyboard/mu68/mu68_ultra'
import { Mu68ProCyan } from './keyboard/mu68/mu68_pro_cyan'
import { Polar75 } from './keyboard/polar75'
import { Amber358 } from './mouse/amber358'
import { Amber358Wired } from './mouse/amber358_wired'
import { Mars68 } from './keyboard/mars68/mars68'
import { Mars68SE } from './keyboard/mars68/mars68se'
import { Mars68Pro } from './keyboard/mars68/mars68pro'
import { Mars68Pro_Wireless } from './keyboard/mars68/mars68pro_wireless'
import { Mars68Pro_Wireless_24g } from './keyboard/mars68/mars68pro_wireless_24g'
import { Mars68_Wireless } from './keyboard/mars68/mars68_wireless'
import { Mars68_Wireless_24g } from './keyboard/mars68/mars68_wireless_24g'
import { Mg68Pro } from './keyboard/mg68/mg68_pro'
import { Mg68SE } from './keyboard/mg68/mg68_se'
import { Mg68 } from './keyboard/mg68/mg68'
import { Mg68Max } from './keyboard/mg68/mg68_max'
import { Mg68LITE } from './keyboard/mg68/mg68_lite'
import { Mg68Max_24g } from './keyboard/mg68/mg68_max_24g'
import { Mg75 } from './keyboard/mg75/mg75'
import { Mg75Pro } from './keyboard/mg75/mg75_pro'
import { Mer68SE } from './keyboard/mer68/mer68se'
import { Mer68 } from './keyboard/mer68/mer68'
import { Mer68Lite } from './keyboard/mer68/mer68lite'
import { Mer68Pro } from './keyboard/mer68/mer68pro'
import { He6Ultra } from './mouse/he6_ultra'
import { Mg68Plus } from './keyboard/mg68/mg68_plus'
import { Mg75Max } from './keyboard/mg75/mg75_max'
import { Mg68ACE } from './keyboard/mg68/mg68_ace'
import { Mg68ACE_UpPlus } from './keyboard/mg68/mg68_ace_up_plus'
import { Mg68ACE_W } from './keyboard/mg68/mg68_ace_w'
import { Mg68ACE_W_24G } from './keyboard/mg68/mg68_ace_w_24g'
import { Mars75 } from './keyboard/mars75/mars75'
import { ND68Pro } from './keyboard/nd/nd68_pro'
import { ND63Ultra } from './keyboard/nd/nd63_ultra'
import { ND68 } from './keyboard/nd/nd68'
import { ND63Max } from './keyboard/nd/nd63_max'
import { Mer68Max } from './keyboard/mer68/mer68max'
import { Mars75Pro } from './keyboard/mars75/mars75_pro'
import { FE87V2 } from './keyboard/fe87v2/fe87_v2'
import { FE87V2Pro } from './keyboard/fe87v2/fe87_v2_pro'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { adjustableKeys } from '@libs/define/adjustable_keys'
import { Mer68SESelfDev } from './keyboard/mer68se_self_dev'
import { RA68 } from './keyboard/ra/ra68'
import { MG63 } from './keyboard/mg63/mg63'
import { RA68_HuoChaiRen } from './keyboard/ra/ra68_huochairen'
import { FE87V2MuYan } from './keyboard/fe/fe87_muyan'
import { MG75V2C12 } from './keyboard/mg75/mg75v2c12'
import { Mer68SE_JT } from './keyboard/mer68/mer68se_jt'

const devicesMap: Map<DevicePid, BaseDevice> = new Map()

/**
 * 只读访问设备注册表（pid -> BaseDevice）。
 * 仅供批量造数等需要枚举全部已注册设备的场景使用；普通业务请用 getDevice()。
 */
export const getRegisteredDevices = (): ReadonlyMap<DevicePid, BaseDevice> => devicesMap

devicesMap.set(DevicePid.IROKAl87, new AL87())
devicesMap.set(DevicePid.IROKAl87Pro, new AL87PRO())
devicesMap.set(DevicePid.IROKAl87Rgb, new AL87RGB())
devicesMap.set(DevicePid.IROKFe75Pro, new FE75PRO())
devicesMap.set(DevicePid.IROKHe2, new He2())
devicesMap.set(DevicePid.IROKFe98Pro, new FE98PRO())
devicesMap.set(DevicePid.IROKMg87, new Mg87())
devicesMap.set(DevicePid.IYXOp75, new OP75())
devicesMap.set(DevicePid.IYXTp87, new TP87())
devicesMap.set(DevicePid.IYXMt87, new Mt87())
devicesMap.set(DevicePid.IROKQMKLi75, new LI75())
devicesMap.set(DevicePid.IYXMu68, new Mu68())
devicesMap.set(DevicePid.IROKNd75, new ND75())
devicesMap.set(DevicePid.IROKNA87, new NA87())
devicesMap.set(DevicePid.IROKHe3SE_Wireless_24g, new He3SE())
devicesMap.set(DevicePid.IROKHe3SE_Wireless, new He3SE())

devicesMap.set(DevicePid.IROKNa87Pro, new NA87Pro())
devicesMap.set(DevicePid.IROKNd63, new ND63())
devicesMap.set(DevicePid.IYXMu68Pro, new Mu68Pro())
devicesMap.set(DevicePid.IROKNd63_cyan, new ND63Cyan())
devicesMap.set(DevicePid.IYXMu68Pro_cyan, new Mu68ProCyan())
devicesMap.set(DevicePid.IYXMu68_ULTRA, new Mu68Ultra())
devicesMap.set(DevicePid.IYXPolar75, new Polar75())
devicesMap.set(DevicePid.IYXAmber358_24g8k, new Amber358())
devicesMap.set(DevicePid.IYXAmber358_Wired, new Amber358Wired())

devicesMap.set(DevicePid.CarotmasMars68Pro_Wireless, new Mars68Pro_Wireless())
devicesMap.set(DevicePid.CarotmasMars68Pro_Wireless_24g, new Mars68Pro_Wireless_24g())
devicesMap.set(DevicePid.CarotmasMars68SE, new Mars68SE())
devicesMap.set(DevicePid.CarotmasMars68, new Mars68())
devicesMap.set(DevicePid.CarotmasMars68_Wireless, new Mars68_Wireless())
devicesMap.set(DevicePid.CarotmasMars68_Wireless_24g, new Mars68_Wireless_24g())
devicesMap.set(DevicePid.CarotmasMars68Pro, new Mars68Pro())

devicesMap.set(DevicePid.MonsGeek, new Mars68Pro_Wireless())
devicesMap.set(DevicePid.MonsGeek_NoLight, new Mars68Pro_Wireless())
devicesMap.set(DevicePid.MonsGeek_NoLight_24g, new Mars68Pro_Wireless())

devicesMap.set(DevicePid.IROKMg68, new Mg68())
devicesMap.set(DevicePid.IROKMg68Pro, new Mg68Pro())
devicesMap.set(DevicePid.IROKMg68Max, new Mg68Max())
devicesMap.set(DevicePid.IROKMg68Max_24g, new Mg68Max_24g())
devicesMap.set(DevicePid.IROKMg68SE, new Mg68SE())
devicesMap.set(DevicePid.IROKMg68LITE, new Mg68LITE())
devicesMap.set(DevicePid.IROKMg75, new Mg75())
devicesMap.set(DevicePid.IROKMg75PRO, new Mg75Pro())

devicesMap.set(DevicePid.CarotmasMer68, new Mer68())
devicesMap.set(DevicePid.CarotmasMer68SE, new Mer68SE())
devicesMap.set(DevicePid.CarotmasMer68Lite, new Mer68Lite())
devicesMap.set(DevicePid.CarotmasMer68Pro, new Mer68Pro())
devicesMap.set(DevicePid.CarotmasMer68Max, new Mer68Max())
devicesMap.set(DevicePid.CarotmasMer68SE_JT, new Mer68SE_JT())

devicesMap.set(DevicePid.He6Ultra, new He6Ultra()) // He6Ultra is not implemented yet
devicesMap.set(DevicePid.He6Ultra_24g, new He6Ultra()) // He6Ultra is not implemented yet

devicesMap.set(DevicePid.IROKMg68Plus, new Mg68Plus())
devicesMap.set(DevicePid.IROKMg75Max, new Mg75Max())
devicesMap.set(DevicePid.IROKMG68ACE, new Mg68ACE())
devicesMap.set(DevicePid.IROKMG68ACE_UpPlus, new Mg68ACE_UpPlus())
devicesMap.set(DevicePid.IROKMG68ACE_W, new Mg68ACE_W())
devicesMap.set(DevicePid.IROKMG68ACE_W_24g, new Mg68ACE_W_24G())

devicesMap.set(DevicePid.CarotmasMars75, new Mars75())
devicesMap.set(DevicePid.CarotmasMars75Pro, new Mars75Pro())
devicesMap.set(DevicePid.IROKND68Pro, new ND68Pro())
devicesMap.set(DevicePid.IROKND63Ultra, new ND63Ultra())

devicesMap.set(DevicePid.IROKND68, new ND68())
devicesMap.set(DevicePid.IROKND63Max, new ND63Max())
devicesMap.set(DevicePid.IROKRA68, new RA68())

devicesMap.set(DevicePid.IrokFe87V2, new FE87V2())
devicesMap.set(DevicePid.IrokFe87V2_24g, new FE87V2())
devicesMap.set(DevicePid.IrokFe87V2C18, new FE87V2())
devicesMap.set(DevicePid.CarotmasMer68SESelfDev, new Mer68SESelfDev())
devicesMap.set(DevicePid.IrokFe87V2IMC, new FE87V2Pro())
devicesMap.set(DevicePid.IrokFe87V2IMC_24g, new FE87V2Pro())
devicesMap.set(DevicePid.IROKMG63, new MG63())
devicesMap.set(DevicePid.IROKMG75V2C12, new MG75V2C12())
devicesMap.set(DevicePid.IROKRA68_1, new RA68_HuoChaiRen())
devicesMap.set(DevicePid.IROKFE87V2_MuYan, new FE87V2MuYan())

export const getDevice = (pid: DevicePid): BaseDevice | null => {
  let device = devicesMap.get(pid)
  return device || null
}

// TODO: 找不到的情况下，返回null，而不是空对象
export const getCurrentDevice = computed((): BaseDevice => {
  const current = getDevice(DeviceManager.instance.state.currentPid)
  if (!current) {
    console.log('current device is null')
  }
  return getDevice(DeviceManager.instance.state.currentPid) || new BaseDevice()
})

export const getCurrentDeviceKKs = computed((): KK[] => {
  if (DeviceManager.instance.state.currentPid == DevicePid.None) {
    return []
  }
  return Object.keys(kks.value).map((key) => Number(key) as KK)
})

export const getCurrentDeviceMagnetKKs = computed((): KK[] => {
  if (DeviceManager.instance.state.currentPid == DevicePid.None) {
    return []
  }
  if (specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)) {
    return adjustableKeys(DevicePid.IrokFe87V2IMC)
  }
  return Object.keys(kks.value).map((key) => Number(key) as KK)
})
